/* eslint-disable @typescript-eslint/no-unused-vars */
import { useState } from "react";
import { IconArchive, IconRefresh, IconPlus } from "@tabler/icons-react";
import MessageModal from "../../../components/MessageModal"; 
import toast from "react-hot-toast"; 
import { useUpdateShelveStatusMutation } from "../../../apis/shelveApis";

interface RackLevelElementProps {
  rackLevelId: string;
  rackLevelName: string;
  rackLevel: any;
  fetchShelves: () => void;
}

const RackLevelElement: React.FC<RackLevelElementProps> = ({
  rackLevelId,
  rackLevelName,
  rackLevel,
  fetchShelves,
}) => {
  const [archiveInstanceOpen, setArchiveInstanceOpen] = useState(false); 

  const isActive = rackLevel?.status !== "INACTIVE";

  const { mutate: toggleLevelStatus, isPending } =
    useUpdateShelveStatusMutation();

  const handleToggleLevel = () => {
    toggleLevelStatus(
      {
        id: rackLevelId,
        status: isActive ? "INACTIVE" : "ACTIVE",
        type: "level",
      },
      {
        onSuccess: () => {
          setArchiveInstanceOpen(false);
          toast.success("Status updated successfully");
          fetchShelves();
        },
        onError: (err: any) => {
          toast.error(err.message);
        },
      },
    );
  };

  return (
    <>
      <div
        className={`px-2 transition-all ${!isActive ? "opacity-60 grayscale-[0.5]" : ""}`}
      >
        <div
          className={`border p-3 space-y-3 rounded-xl shadow-sm hover:border-blue-400 transition-colors group ${
            isActive
              ? "bg-white border-gray-200"
              : "bg-gray-100 border-gray-300"
          }`}
        >
          <div className="flex justify-between items-center">
            <div className="flex items-center gap-2">
              <h5 className="font-bold text-sm text-gray-800">
                {rackLevelName}
              </h5>
              <span
                className={`px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-wider ${
                  isActive
                    ? "bg-blue-50 text-blue-600"
                    : "bg-gray-300 text-gray-600"
                }`}
              >
                {isActive ? "Active Level" : "Inactive"}
              </span>
            </div>

            <div className="flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
              <button
                onClick={() => setArchiveInstanceOpen(true)}
                className={`p-1 rounded ${isActive ? "hover:bg-red-50 text-red-500" : "hover:bg-blue-50 text-blue-600"}`}
                title={isActive ? "Archive Level" : "Restore Level"}
              >
                {isActive ? (
                  <IconArchive size={18} />
                ) : (
                  <IconRefresh size={18} />
                )}
              </button>
            </div>
          </div>
        </div>

       
      </div>
      <MessageModal
        open={archiveInstanceOpen}
        onClose={() => setArchiveInstanceOpen(false)}
        title={isActive ? "Deactivate Level?" : "Reactivate Level?"}
        subtitle={
          isActive
            ? "This will hide all bins in this level from daily operations."
            : "This will make all bins in this level available again."
        }
        img={isActive ? "/img/archive.png" : "/img/reset.png"}
        showFooter={true}
        actionButtonText={isActive ? "Archive Level" : "Restore Level"}
        actionButtonOnClick={handleToggleLevel}
        isPending={isPending}
      />
    </>
  );
};

export default RackLevelElement;
